import React, { useRef, useState } from 'react';
import './CreatorShowcase.css';
import { ChevronLeft, ChevronRight} from 'lucide-react';
import star1 from '../../Images/star1.png'
import star2 from '../../Images/star2.png'
import star3 from '../../Images/star3.png'
import star4 from '../../Images/star4.png'
import star5 from '../../Images/star5.png'
import star6 from '../../Images/star1copy.png'
import star7 from '../../Images/star2copy.png'
import star8 from '../../Images/star3copy.png'
import star9 from '../../Images/star4copy.png'
import star10 from '../../Images/star5copy.png'

import insta from '../../Images/instalogo.png'

const creators = [
  {
    id: 1,
    image: star1,
    handle: '@creativemind',
    followers: '10.2k Followers',
  },
  {
    id: 2,
    image: star2,
    handle: '@techguru',
    followers: '8.7k Followers',
  },
  {
    id: 3,
    image: star3,
    handle: '@iamdenis',
    followers: '4.7k Followers',
  },
  {
    id: 4,
    image: star4,
    handle: '@fitnessjunkie',
    followers: '15.3k Followers',
  },
  {
    id: 5,
    image: star5,
    handle: '@foodielove',
    followers: '6.5k Followers',
  }, 
  {
    id: 6,
    image: star6,
    handle: '@creativemind',
    followers: '10.2k Followers',
  },
  {
    id: 7,
    image: star7,
    handle: '@techguru',
    followers: '8.7k Followers',
  },
  {
    id: 8,
    image: star8,
    handle: '@iamdenis',
    followers: '4.7k Followers',
  },
  {
    id: 9,
    image: star9,
    handle: '@fitnessjunkie',
    followers: '15.3k Followers',
  },
  {
    id: 10,
    image: star10,
    handle: '@foodielove',
    followers: '6.5k Followers',
  },
  
  
];

export default function CreatorShowcase() {
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const scroll = (direction) => {
    if (carouselRef.current) {
      const cardWidth = 240; 
      const newIndex =
        direction === 'left'
          ? Math.max(currentIndex - 1, 0)
          : Math.min(currentIndex + 1, creators.length - 1);

      setCurrentIndex(newIndex);

      carouselRef.current.scrollTo({
        left: newIndex * cardWidth,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="creatorcontainer">
      <h1 className="title">Meet the Businessbay Stars</h1>
      <p className="subtitle">
        Tap into the Community of Top Creators Across Every Niche.
      </p>

      <div className="carouselContainer">
        <div className="carousel" ref={carouselRef}>
          {creators.map((creator) => (
            <div key={creator.id} className="card">
              <img
                src={creator.image}
                alt="Creator"
                className="cardImage"
                width={220}
                height={280}
              />
              <div className="cardOverlay">
                <div className="socialHandle">
                  <img src={insta} className='instalogo' alt='insta logo'/>
                  {creator.handle}
                </div>
                <div className="followers">{creator.followers}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="bottomNavigation">
          <button
            className="bottomNavButton"
            onClick={() => scroll('left')}
            disabled={currentIndex === 0}
            aria-label="Previous"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            className="bottomNavButton"
            onClick={() => scroll('right')}
            disabled={currentIndex === creators.length - 1}
            aria-label="Next"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}

